import IconNameEnum from "constants/IconNameEnum";
import React from "react";
import BaseContent from "../base-content/BaseContent";
import BaseModal from "../base-content/BaseModal";
import BaseButton from "./BaseButton";
import BaseIcon from "./BaseIcon";

interface IProps {
    label?: string;
    code: string;
}

interface IState {
    showModal: boolean;
}

class InfoIcon extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            showModal: false,
        } as IState;
    }

    private hasUnmounted = false;

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private toggleModal = (status: boolean) => {
        if (this.hasUnmounted === false) {
            this.setState({ showModal: status });
        }
    };

    public render(): JSX.Element {
        const { label, code } = this.props;
        const { showModal } = this.state;

        return (
            <>
                <span
                    className="mx-2 text-secondary font-weight-bold cursor-pointer"
                    title={"Numero elementi per pagina"}
                    onClick={() => this.toggleModal(true)}
                >
                    <BaseIcon icon={IconNameEnum.Info} />
                </span>

                <BaseModal
                    show={showModal}
                    size="lg"
                    onHideHandler={() => this.toggleModal(false)}
                    closeOnOutClick={true}
                    centered={true}
                    title={label}
                    body={<BaseContent contentCode={code} />}
                    footer={
                        <BaseButton
                            type="button"
                            color="grey"
                            label={"Chiudi"}
                            icon={IconNameEnum.Info}
                            onClickHandler={() => this.toggleModal(false)}
                        />
                    }
                />
            </>
        );
    }
}

export { InfoIcon as Unconnected };
export default InfoIcon;
